/* ==========================================================================
   Header navigation — mobile drawer + submenu dropdowns.

   Progressive enhancement: the markup renders as a plain nested list, and a
   <noscript> block in sections/header.liquid reveals it inline on small
   screens. Everything below only ever adds behaviour on top of that.

   Desktop dropdowns open on hover and :focus-within via CSS alone; the
   toggle buttons exist for touch and keyboard, and are the only mechanism
   on mobile where the whole nav is a drawer.
   ========================================================================== */

(function () {
  'use strict';

  var DESKTOP = '(min-width: 760px)';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  var nav = header.querySelector('[data-nav]');
  var navToggle = header.querySelector('[data-nav-toggle]');
  var subToggles = Array.prototype.slice.call(
    header.querySelectorAll('[data-nav-submenu-toggle]')
  );

  if (!nav || !navToggle) return;

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function setDrawer(open) {
    nav.classList.toggle('is-open', open);
    navToggle.setAttribute('aria-expanded', String(open));
  }

  function drawerOpen() {
    return nav.classList.contains('is-open');
  }

  function closeSubmenus(except) {
    subToggles.forEach(function (btn) {
      if (btn !== except) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function openSubmenu() {
    return subToggles.filter(function (btn) {
      return btn.getAttribute('aria-expanded') === 'true';
    })[0];
  }

  function closeEverything() {
    closeSubmenus();
    setDrawer(false);
  }

  navToggle.addEventListener('click', function () {
    var next = !drawerOpen();
    setDrawer(next);
    if (!next) closeSubmenus();
  });

  subToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = btn.getAttribute('aria-expanded') !== 'true';
      /* Only one dropdown at a time on desktop; the drawer can stack them. */
      if (next && isDesktop()) closeSubmenus(btn);
      btn.setAttribute('aria-expanded', String(next));
    });
  });

  document.addEventListener('click', function (event) {
    if (!header.contains(event.target)) closeEverything();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var open = openSubmenu();
    if (open) {
      open.setAttribute('aria-expanded', 'false');
      open.focus();
      return;
    }
    if (drawerOpen()) {
      setDrawer(false);
      navToggle.focus();
    }
  });

  /* A focus that lands outside the header (tabbing past the last link)
     should leave nothing hanging open behind it. */
  document.addEventListener('focusin', function (event) {
    if (!header.contains(event.target)) closeEverything();
  });

  /* Crossing the breakpoint with the drawer open would strand it half-styled. */
  var desktopQuery = window.matchMedia(DESKTOP);
  var onBreakpoint = function (event) {
    if (event.matches) closeEverything();
  };

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', onBreakpoint);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(onBreakpoint);
  }
})();
